"use client";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TransactionFilters from "../components/TransactionFilters";
import TransactionList from "../components/TransactionList";
import { Icons } from "../assets/icons/Icons";

const transactions = [
    {
        id: 1,
        type: "withdraw",
        description: "From Crypto",
        amount: -53.95,
        date: "March 14, 2021",
        month: "March 2025",
    },
    {
        id: 2,
        type: "deposit",
        description: "From Crypto",
        amount: 2500.95,
        date: "April 14, 2021",
        month: "March 2025",
    },
    {
        id: 3,
        type: "deposit",
        description: "Coffe with Sarah",
        amount: 5.42,
        date: "April 12, 2021",
        month: "March 2025",
    },
    {
        id: 4,
        type: "plan_activation",
        description: "Starter Plan",
        amount: 999.0,
        date: "April 09, 2021",
        month: "March 2025",
    },
    {
        id: 5,
        type: "withdraw",
        description: "From Crypto",
        amount: -53.95,
        date: "March 14, 2021",
        month: "February 2025",
    },
    {
        id: 6,
        type: "exchange",
        description: "ETH to USD",
        amount: 2500.95,
        date: "April 14, 2021",
        month: "February 2025",
    },
    {
        id: 7,
        type: "deposit",
        description: "Coffe with Sarah",
        amount: 5.42,
        date: "April 12, 2021",
        month: "February 2025",
    },
    {
        id: 8,
        type: "plan_activation",
        description: "Starter Plan",
        amount: 999.0,
        date: "April 09, 2021",
        month: "February 2025",
    },
];

export const Activity = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState("All Transaction");

    const filteredTransactions =
        activeFilter === "All Transaction"
            ? transactions
            : transactions.filter(
                  (transaction) => transaction.type === activeFilter
              );

    return (
        <div
            className="d-flex flex-column"
            // style={{
            //     backgroundImage: "url('./images/store/recent_activity_bg.png')",
            //     backgroundRepeat: "no-repeat",
            //     backgroundSize: "cover",
            //     backgroundPosition: "center top",
            //     backgroundColor: "#000000",
            //     minHeight: "100vh",
            //     position: "relative",
            //     paddingBottom: "80px",
            // }}
        >
            <div className="d-flex justify-content-start pt-3 mx-2 pb-3 px-2 pt-4">
                <Link
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <Icons.BackWithBG />
                </Link>
                <h2 className="font-33 font-700" style={{ marginLeft: "12px" }}>
                    Recent Activity
                </h2>
            </div>

            <div className="pt-4 flex-grow-1">
                <TransactionFilters
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                />
                <div className="px-3">
                    <TransactionList transactions={filteredTransactions} />
                </div>
            </div>
        </div>
    );
};
